import { useState } from "react";
import { BallIcon, human, right_arrow } from "../../assets/icons";
import TestimonialPage from "../../components/Testimonial/Testimonial";
import "./Home.css";
import CustomModal from "../../components/Modal/Modal";
import { useNavigate } from "react-router-dom";
import homeData from "../../shared/data/homeData.json";
import { Helmet } from "react-helmet";
import { useCursor } from "../../shared/config/cursorProvider";
import { AV, Allets, Duckman, MDS, amaologic } from "../../assets/images";
import { useSelector } from "react-redux";
import { selectSimpleMode } from "../../store/globalSlice";
import SimpleMode from "../SimpleMode/SimpleMode";
import { ToggleMode } from "../../components/Navbar/Nav";

const Home = () => {
  const simpleMode = useSelector(selectSimpleMode);
  const navigate = useNavigate();
  const [selectedService, setSelectedService] = useState(null);
  const [showPopover, setShowPopover] = useState(false);
  const handleReadMoreClick = (service) => {
    setSelectedService(service);
    setShowPopover(true);
  };
  const cursorPosition = useCursor();
  const metaDescription = homeData.heroText;
  if (simpleMode) {
    return <SimpleMode />;
  }
  return (
    <div className="home-container">
       <div className="toggle-s-mode">
        <ToggleMode />
      </div>
      <Helmet>
        <meta name="description" content={metaDescription} />
      </Helmet>
      <div
        className="custom-1"
        style={{ left: cursorPosition.x, top: cursorPosition.y }}
      ></div>
      <div
        className="custom-cursor"
        style={{ left: cursorPosition.x, top: cursorPosition.y }}
      ></div>
      <div className="home-box">
        <div className="blur-background"></div>
        <img src={BallIcon} alt="" className="crystal" />
        <div className="hero">
          <div className="hero-content">
            <h1 className="title-text">
              <span className="highlight-txt">Unleash</span> the Web with{" "}
              <span className="highlight-txt">Zivotix</span> Magic.
            </h1>
            <p>{homeData.heroText}</p>
            <button className="button-33" onClick={() => navigate("/contact")}>Get Started</button>
          </div>
        </div>
      </div>
      <div className="our-utility">
        <h2>Our Utility</h2>

        <p className="utility-text">{homeData.utilityText}</p>
        <div className="human-walking">
          <img src={human} alt="" className="human" />
          <div className="button-tour" onClick={() => navigate("/services")}>
            Take a tour
          </div>
        </div>
        <section className="services">
          {homeData.services.map((service, index) => (
            <ServiceComponent
              key={index}
              handleReadMoreClick={() => handleReadMoreClick(service)}
              {...service}
            />
          ))}
        </section>
        <div className="trust-tales">
          <h3 className="title-text">
            Building Relationships:
            <span className="highlight-txt"> Proud Partners in Success</span>
          </h3>
          <OurClients />
        </div>

        <div className="testimonial-section">
          <h2>
            Client <span className="testimony">Testimony</span> Tales
          </h2>
          <div>
            <div className="client">
              <p>{homeData.ClientText}</p>
              <img src={right_arrow} alt="" className="right-arrow" />
            </div>
          </div>
          <TestimonialPage />
        </div>
      </div>
      {showPopover && (
        <CustomModal onClose={() => setShowPopover(false)}>
          <h3>{selectedService.title}</h3>
          <p>{selectedService.about}</p>
        </CustomModal>
      )}
    </div>
  );
};

export default Home;

export const ServiceComponent = ({
  icon,
  title,
  about,
  handleReadMoreClick,
  simpleMode,
  index,
}) => {
  const navigate = useNavigate()
  const isEven = index % 2 === 0;
  const backgroundColor = isEven && simpleMode ? "#cad8ff" : "#6F87E9";
  const color = isEven && simpleMode ? "black" : "#fff";
  return (
    <div
      className={simpleMode ? "s-service" : "service"}
      style={{
        background: simpleMode && backgroundColor,
        color: simpleMode && color,
      }}
      onClick={() => navigate('/services')}
    >
      {/* <img src={icon} alt="" /> */}
      <p>{title}</p>
      <p className="service-about">
        {about.length > 60 ? `${about.slice(0, 60)}...` : about}
      </p>
      {about.length > 20 && (
        <p className="service-read" onClick={handleReadMoreClick}>
          Read More
        </p>
      )}
    </div>
  );
};

export const OurClients = () => {
  return (
    <div className="brand-logos">
      <img src={Allets} alt="" />
      <img src={MDS} alt="" />
      <img src={amaologic} alt="" />
      <img src={AV} alt="" />
      <img src={Duckman} alt="" />
    </div>
  );
};
